import { reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { toast, variant } from '@/core/helper/utility'
import { httpStatusCode } from '@/core/helper/httpStatusCode';
import { GetAll, Create } from "@/infrastructure/repositories/contactRepository"

export const useContact = () => {
    var filter = reactive({});
    var contacts = ref([]);
    var contact = reactive({
        name: null,
        phone: null,
        email: null,
        brand: null,
    });
    var isCreateContactModal = ref(false);
    var isLoading = ref(false);
    var isCreateLoading = ref(false);

    const contactRules = {
        name: { required },
        phone: { required, },
        email: { email },
        brand: {
            id: {
                required
            }
        }
    }

    const validate$ = useVuelidate(contactRules, contact, { $scope: false });

    const onCreateHandle = async () => {
        try {
            const isValid = await validate$.value.$validate();
            if(!isValid){
                return;
            }

            isCreateLoading.value = true;

            var response = await Create({
                name: contact.name,
                phone: contact.phone,
                email: contact.email,
                idbrand: contact.brand.id,
            });

            if(response.status == httpStatusCode.OK){
                toast({
                    variant: variant.success,
                    title: response.data.title,
                    body:  response.data.message
                });

                contacts.value.push({
                    ...response.data.value,
                    brand: contact.brand
                });

                isCreateContactModal.value = false;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }
            isCreateLoading.value = false;
        } catch (error) {
            isCreateLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Contacts',
                body: 'Could not get contact list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    const getContacts = async () => {
        try {
            isLoading.value = true;

            var response = await GetAll(filter);
            if(response.status == httpStatusCode.OK){
                contacts.value = response.data.value;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }
            isLoading.value = false;
        } catch (error) {
            isLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Contacts',
                body: 'Could not get contact list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    return {
        validate$,
        isLoading,
        isCreateLoading,
        isCreateContactModal,
        contacts,
        contact,
        getContacts,
        onCreateHandle
    }
}